<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-4': $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <v-layout row wrap align-center
                          justify-space-between mb-4 :class="{'px-3': $vuetify.breakpoint.xs}"
                >
                    <v-flex sm7 xs12>
                        <h1 class="section-title-main my-3 font-weight-regular">{{ $t("Рейтинг и баллы") }}</h1>
                    </v-flex>
                    <v-flex sm5 xs12 text-sm-right
                            text-xs-left
                    >
                        <router-link :to="{name: 'points_history'}">
                            <buttonBdWhite>{{ $t("История начисления баллов") }}</buttonBdWhite>
                        </router-link>
                        <div v-if="!disabled" style="margin: 10px 0;">
                            <router-link :to="disabled ? {name: 'rating'} : {name: 'prize_shop'}">
                                <buttonBdWhite :disabled="disabled" style="width: 274.47px; max-width: 100%">{{ $t("Каталог призов") }}</buttonBdWhite>
                            </router-link>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-tabs
                            v-model="active_tab"
                            slot="extension"
                            color="white"
                            :slider-color="tabsColor"
                            show-arrows
                        >
                            <v-tab v-if="rating_organizations_in_managment" class="wrapper-relative" href="#organizations">
                                <v-layout row wrap align-center>
                                    <v-flex md2>
                                        <svg v-svg
                                             symbol="rating_org"
                                             size="32 32"
                                             class="icon"
                                             role="presentation"
                                        />
                                    </v-flex>
                                    <v-flex sm12 xs12 md9
                                            :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                    >{{ $t("Рейтинг организаций") }}</v-flex>
                                </v-layout>
                            </v-tab>
                            <v-tab v-if="user_rating_in_organization" class="wrapper-relative" href="#org_employee">
                                <v-layout row wrap align-center>
                                    <v-flex md2>
                                        <svg v-svg
                                             symbol="rating_org_employee"
                                             size="32 32"
                                             class="icon"
                                             role="presentation"
                                        />
                                    </v-flex>
                                    <v-flex sm12 xs12 md9
                                            :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                    >{{ $t("Рейтинг сотрудников организации") }}</v-flex>
                                </v-layout>
                            </v-tab>
                            <v-tab v-if="common_rating" class="wrapper-relative" href="#all">
                                <v-layout row wrap align-center>
                                    <v-flex md2>
                                        <svg v-svg
                                             symbol="rating_all"
                                             size="32 32"
                                             class="icon"
                                             role="presentation"
                                        />
                                    </v-flex>
                                    <v-flex sm12 xs12 md9
                                            :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                    >{{ $t("Общий рейтинг сотрудников") }}</v-flex>
                                </v-layout>
                            </v-tab>
                            <v-tab v-if="test_results" class="wrapper-relative" href="#tests_result">
                                <v-layout row wrap align-center>
                                    <v-flex md2>
                                        <svg v-svg
                                             symbol="result_user"
                                             size="32 32"
                                             class="icon"
                                             role="presentation"
                                        />
                                    </v-flex>
                                    <v-flex sm12 xs12 md9
                                            :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                    >{{ $t("Результаты проверочного тестирования") }}</v-flex>
                                </v-layout>
                            </v-tab>

                            <v-tabs-items class="mt-5 mb-5">
                                <v-layout align-start wrap>
                                    <v-flex :xl9="active_tab !== 'tests_result'" :lg8="active_tab !== 'tests_result'" :md8="active_tab !== 'tests_result'"
                                            :sm12="active_tab !== 'tests_result'" :xs12="active_tab !== 'tests_result'" :class="{'order-md1': $vuetify.breakpoint.mdAndUp}"
                                    >
                                        <v-tab-item v-if="rating_organizations_in_managment"
                                                    value="organizations"
                                        >
                                            <div class="display-1 mb-4" :class="{'px-3': $vuetify.breakpoint.xs}">{{ $t("Рейтинг организаций") }}</div>
                                            <ratingTable :total="rating_companies.content.pagination.total"
                                                         :table="rating_companies" type="organizations" :loading="loading"
                                            />
                                            <ratingPagination :table="rating_companies" :tab="tabs" />
                                        </v-tab-item>
                                        <v-tab-item value="org_employee">
                                            <div class="display-1 mb-4" :class="{'px-3': $vuetify.breakpoint.xs}">{{ $t("Сотрудники") }} {{ user.company_name }}</div>
                                            <ratingTable :entity="user_in_company_rating" :total="rating_org_employees.content.pagination.total"
                                                         :table="rating_org_employees" type="org_employee" :loading="loading"
                                            />
                                            <ratingPagination :table="rating_org_employees" :tab="tabs" />
                                        </v-tab-item>
                                        <v-tab-item value="all">
                                            <div class="display-1 mb-4" :class="{'px-3': $vuetify.breakpoint.xs}"></div>
                                            <ratingTable :total="rating_common_employees.content.pagination.total"
                                                         :table="rating_common_employees" type="all" :loading="loading"
                                            />
                                            <ratingPagination :table="rating_common_employees" :tab="tabs" />
                                        </v-tab-item>
                                        <v-tab-item value="tests_result">
                                            <h2 class="section-title mt-3 mb-4 ml-0">{{ $t("Результаты проверочного тестирования") }}</h2>
                                            <dataTable
                                                :total="employee_study_courses_verification.content.pagination.total"
                                                :request="{}"
                                                :table="employee_study_courses_verification"
                                                type="courses_verification"
                                            />
                                            <ratingPagination :table="employee_study_courses_verification" :tab="tabs" />
                                        </v-tab-item>
                                    </v-flex>
                                </v-layout>
                            </v-tabs-items>
                        </v-tabs>
                    </v-flex>
                </v-layout>
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import {mapGetters, mapActions, mapMutations} from 'vuex';
import ratingTable from '@/components/view_blocks/Rating/Rating_table';
import ratingPagination from '@/components/view_blocks/Rating/Rating_pagination';
import dataTable from '@/components/view_blocks/Employee_study/Employee_study_table.vue';

export default {
  components: {
    dataTable,
    ratingPagination,
    ratingTable,
    HeaderMenu,
    UserMenu,
    FooterBlock,
    buttonBdWhite,
  },
  data() {
    return {
      tabs                             : localStorage.getItem('active_tab_rating') || 'organizations',
      rating_organizations_in_managment: false,
      common_rating                    : false,
      my_prizes                        : false,
      user_rating_in_organization      : false,
      test_results                     : false,
    };
  },
  watch: {
    tabs() {
      localStorage.setItem('active_tab_rating', this.tabs);
    },
  },
  computed: {
    disabled() {
      const user = JSON.parse(localStorage.getItem('user'));
      const access = user.access_catalog;

      return !((user.achievments.name === 'Эксперт' || user.achievments.name === 'Знаток') && access);
    },
    ...mapGetters('employee_study/coursesVerification', [
      'employee_study_courses_verification',
    ]),
    ...mapGetters('rating', [
      'loading',
      'user_rating',
      'user_in_company_rating',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('rating/companies', [
      'rating_companies',
    ]),
    ...mapGetters('rating/org_employees', [
      'rating_org_employees',
      'current_org_employee_rating',
    ]),
    ...mapGetters('rating/common_employees', [
      'rating_common_employees',
      'current_common_employee_rating',
    ]),
    ...mapGetters('employee_study/organizations', [
      'employee_study_org',
      'showed_org_filter',
    ]),
    tabsColor() {
      if (this.tabs === 'organizations') {
        return '#84a45d';
      } else if (this.tabs === 'internal_employee') {
        return '#2755cf';
      } else if (this.tabs === 'org_employee') {
        return '#44b69e';
      } else if (this.tabs === 'all') {
        return '#e2173d';
      } else if (this.tabs === 'tests_result') {
        return '#e2173d';
      }
    },
    active_tab: {
      get() {
        return this.tabs;
      },
      set($event) {
        this.tabs = $event;

        if (this.active_tab === 'organizations') {
          this.SET_COMPANY_PAGE(1);
          this.get_org_rating({
            page    : this.rating_companies.content.pagination.page,
            pageSize: this.rating_companies.content.pagination.rowsPerPage,
          });
        } else if (this.active_tab === 'org_employee') {
          this.SET_ORG_EMPLOYEES_PAGE(1);
          this.get_employees_rating({
            page    : this.rating_org_employees.content.pagination.page,
            pageSize: this.rating_org_employees.content.pagination.rowsPerPage,
          });
        } else if (this.active_tab === 'all') {
          this.SET_COMMON_EMPLOYEES_PAGE(1);
          this.get_common_rating({
            page    : this.rating_common_employees.content.pagination.page,
            pageSize: this.rating_common_employees.content.pagination.rowsPerPage,
          });
        } else if (this.active_tab === 'tests_result') {
          this.SET_COURSES_VERIFICATION_PAGE(1);
          this.get_courses_verification({
            filter : {},
            page   : this.employee_study_courses_verification.content.pagination.page,
            perPage: this.employee_study_courses_verification.content.pagination.rowsPerPage,
          });
        }
      },
    },
  },
  async mounted() {
    this.get_user_rating(this.$route.params.id);
    this.get_user_in_company_rating(JSON.parse(localStorage.getItem('user')).company_id);
    this.get_company_rating();
    await this.get_courses_verification({
      filter : {},
      page   : this.employee_study_courses_verification.content.pagination.page,
      perPage: this.employee_study_courses_verification.content.pagination.rowsPerPage,
    });

    this.rating_organizations_in_managment = this.user.role.rating_organizations_in_managment.rights.length;
    this.common_rating = this.user.role.overall_user_rating.rights.length;
    this.user_rating_in_organization = this.user.role.user_rating_in_organization.rights.length;
    this.my_prizes = this.user.role.my_prizes.rights.length;
    this.test_results = this.user.role.rating_and_points.rights.length;

    this.handleLocalStorageTabs();

    if (this.tabs === 'org_employee') {
      await this.get_employees_rating({});
    } else if (this.tabs === 'all') {
      await this.get_common_rating({});
    } else if (this.tabs === 'internal_employee') {
      await this.get_internal_rating();
    } else if (this.tabs === 'organizations') {
      await this.get_org_rating({});
    }
  },
  methods: {
    ...mapActions('rating', [
      'get_org_rating',
      'get_internal_rating',
      'get_employees_rating',
      'get_common_rating',
      'get_company_rating',
      'get_user_rating',
      'get_user_in_company_rating',
    ]),
    ...mapActions('employee_study', [
      'get_courses_verification',
    ]),
    ...mapActions('profile/other_user', [
      'get_other_user',
    ]),
    ...mapMutations('rating/companies', [
      'SET_COMPANY_PAGE',
    ]),
    ...mapMutations('rating/org_employees', [
      'SET_ORG_EMPLOYEES_PAGE',
    ]),
    ...mapMutations('rating/common_employees', [
      'SET_COMMON_EMPLOYEES_PAGE',
    ]),
    ...mapMutations('employee_study/coursesVerification', [
      'SET_COURSES_VERIFICATION_PAGE',
    ]),
    handleLocalStorageTabs() {
      if (this.tabs === 'organizations' && !this.rating_organizations_in_managment) {
        this.tabs = 'org_employee';
      } else if (this.tabs === 'internal_employee' && !this.common_rating) {
        this.tabs = 'org_employee';
      } else if (this.tabs === 'all' && !this.common_rating) {
        this.tabs = 'org_employee';
      }
    },
  },
};
</script>
